import { ResourcePages } from '@backrs_ui/common-ui';

import {
  MakeItPersonalBadge,
  setActiveMakeItPersonalBadge,
} from '@backrs_ui/grow-ui/src/redux/makeItPersonal/makeItPersonal';
import { sendMakeItPersonalAskLubavPrompt } from '@backrs_ui/grow-ui/src/redux/makeItPersonal/makeItPersonal.thunks';
import { AppDispatch } from '@backrs_ui/grow-ui/src/redux/store';

export const handleLifeReadinessBadgeClick = (
  badge: MakeItPersonalBadge,
  activeMakeItPersonalBadge: MakeItPersonalBadge | undefined,
  userId: number | undefined,
  dispatch: AppDispatch,
) => {
  if (activeMakeItPersonalBadge?.id === badge.id) {
    dispatch(setActiveMakeItPersonalBadge(undefined));

    return;
  }

  // if there is no response yet, we call the thunk to get the response
  const isValidResponse = typeof badge.response === 'string' && badge.response.trim() !== '';

  if (!isValidResponse && userId) {
    dispatch(setActiveMakeItPersonalBadge({ ...badge, isLoading: true }));
    dispatch(
      sendMakeItPersonalAskLubavPrompt({
        page: ResourcePages.LIFE_READINESS,
        askLubavBadge: badge,
        user_id: userId,
      }),
    );

    return;
  }

  dispatch(setActiveMakeItPersonalBadge(badge));
};
